import React, { PropsWithChildren, ReactElement } from 'react'

export interface StateControllerProps {
  currentState: string
  nonIdealState?: React.ReactNode
  children?: React.ReactElement<StateProps> | React.ReactElement<StateProps>[]
}
export const StateController: React.FC<StateControllerProps> = ({
  currentState,
  nonIdealState,
  children,
}) => {
  const state = React.Children.map(
    children,
    (child) => child as ReactElement<PropsWithChildren<StateProps>>
  ).filter((child) => child.props.id === currentState)
  return <>{state ? state : nonIdealState}</>
}

export interface StateProps {
  id: string
}
export const State: React.FC<StateProps> = ({ children }) => {
  return <>{children}</>
}
